import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["header", "content"]
    static values = { expanded: Boolean }

    connect() {
        // Check if task should start expanded (for new tasks)
        if (this.expandedValue) {
            this.expanded = true
            // Apply expanded styles
            this.element.classList.remove('my-1', 'py-1.5')
            this.element.classList.add('my-2', 'pt-2', 'pb-1', 'shadow-xs')
        } else {
            this.expanded = false
        }
    }

    toggle(event) {
        // Don't toggle if clicking on select or its children
        if (event.target.closest('.select')) {
            return
        }

        // Don't toggle if clicking on an input
        if (event.target.tagName === 'INPUT') {
            return
        }

        // If already expanded, do nothing (keep it expanded)
        if (this.expanded) {
            return
        }

        // Collapse all other task cards
        document.querySelectorAll('[data-controller="task-card"]').forEach(card => {
            if (card !== this.element && card.taskCardController) {
                card.taskCardController.collapse()
            }
        })

        // Expand this card
        this.expand()
    }

    clickOutside(event) {
        // Only process if this card is expanded
        if (!this.expanded) {
            return
        }

        // Ignore clicks on datepicker calendars (they get removed/recreated on nav)
        if (event.target.closest('.sdp-cal')) {
            return
        }

        // Check if click is outside this task card
        if (!this.element.contains(event.target)) {
            this.collapse()
        }
    }

    expand() {
        this.headerTarget.classList.add('hidden')
        this.contentTarget.classList.remove('hidden')
        this.element.classList.remove('my-1', 'py-1.5')
        this.element.classList.add('my-2', 'pt-2', 'pb-1', 'shadow-xs')
        this.expanded = true
    }

    collapse() {
        this.headerTarget.classList.remove('hidden')
        this.contentTarget.classList.add('hidden')
        this.element.classList.remove('my-2', 'pt-2', 'pb-1', 'shadow-xs')
        this.element.classList.add('my-1', 'py-1.5')
        this.expanded = false
    }

    stopPropagation(event) {
        event.stopPropagation()
    }

    // Store controller instance on element for cross-controller communication
    initialize() {
        this.element.taskCardController = this
    }
}
